import * as React from 'react';
import PersistentDrawerLeft from '../../components/seller/Sidebar';
import { Typography } from "@mui/material"
import { Grid } from "@mui/material"
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import "../../css/seller/ListTransaction.css";
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router';
import LoadingScreen from '../../components/LoadingScreen';

export default function SellerDashboard() {
  const [user, setUser] = React.useState({})
  const [isLoading, setIsLoading] = React.useState(false);
  const headerTable = {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '29px',
    color: '#000000',
  }

  const rowTable = {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    color: '#000000',
  }

  let saldo = 0
  const [cookies, setCookie] = useCookies(['accessToken']);
  const [transaction, setTransaction] = React.useState([]);
  const [earning, setEarning] = React.useState({
    "today": {
      "earnings": '-',
      "count": '-',
    },
    "thisMonth": {
      "earnings": '-',
      "count": '-',
    },
    "thisYear": {
      "earnings": '-',
      "count": '-',
    }
  });
  const navigate = useNavigate();

  React.useEffect(() => {
    setIsLoading(true)
    const validateAccessToken = async () => {
      try {
        // setIsLoading(true);
        const url = 'https://w-shop-backend.vercel.app/api/transactionsSeller';
        const rawResponse = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        });
        const response = await rawResponse.json();
        if (response.status !== 'success') {
          throw new Error(response.message);
        } else {
          setTransaction(response.data);
        }
        const urlEarning = 'https://w-shop-backend.vercel.app/api/earningsSeller';
        const rawResponseEarning = await fetch(urlEarning, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
        });
        const responseEarning = await rawResponseEarning.json();
        if (responseEarning.status !== 'success') {
          throw new Error();
        } else {
          setEarning(responseEarning.data);
          setIsLoading(false);
        }
      } catch (error) {
        setCookie('accessToken', '', { path: '/' });
        navigate('/sellerLogin');
      }
    }
    if (cookies.accessToken === '') {
      navigate('/sellerLogin');
    } else {
      validateAccessToken();
    }
  }, [cookies, navigate, setCookie])

  function createData(codeTrans, user, product, amount, totalPrice, transactionTime) {
    return { codeTrans, user, product, amount, totalPrice, transactionTime };
  }
  const rows = [];

  transaction.map((transactions) => {
    return (transactions.status === true ? (rows.push(createData(
      transactions.codeTrans, transactions.user.name,
      transactions.product.product,
      transactions.amount,
      new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(transactions.price * transactions.amount),
      new Date(transactions.updatedAt).toLocaleString())),
      saldo += (transactions.price * transactions.amount)
    ) : (null))
  });

  let sort = rows.reverse();

  const limit = [];
  for (let index = 0; index < 20; index++) {
    if (sort[index] !== undefined) {
      limit.push(sort[index]);
    } else {
      limit.push(createData('', '', '', '', '', ''))
    }
  }

  let ListTransaction = (<div className='ticket-db-main p-5'>
    <LoadingScreen active={isLoading} />
    <Grid container spacing={2} justifyContent='start' sx={{
      '@media screen and (max-width:1454px)': {
        justifyContent: 'center',
      }
    }}>
      <Grid item >
        <div className="retangle">
          <p className="retangleTitle" style={{ color: '#0E4DA4' }}>Saldo</p>
          <Grid container spacing={2} justifyContent='start'>
            <Grid item xs={3}>
              <img src="/img/iconMoney.png" height={70} width={70} alt=''></img>
            </Grid>
            <Grid item xs={9}>
              <p className="content1">{rows.length} Transactions</p>
              <p className="content2">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(saldo)}</p>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item >
        <div className="retangle">
          <p className="retangleTitle" style={{ color: '#0E4DA4' }}>Earnings (Today)</p>
          <Grid container spacing={2} justifyContent='start'>
            <Grid item xs={3}>
              <img src="/img/money.png" height={35} width={60} style={{ marginTop: '15px' }} alt=''></img>
            </Grid>
            <Grid item xs={9}>
              <p className="content1">{earning.today.count} Transactions</p>
              <p className="content2">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(earning.today.earnings)}</p>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item >
        <div className="retangle">
          <p className="retangleTitle" style={{ color: '#0084B4' }}>Earnings (This Month)</p>
          <Grid container spacing={2} justifyContent='start'>
            <Grid item xs={3}>
              <img src="/img/calender.png" height={50} width={50} alt=''></img>
            </Grid>
            <Grid item xs={9}>
              <p className="content1">{earning.thisMonth.count} Transactions</p>
              <p className="content2">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(earning.thisMonth.earnings)}</p>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid item >
        <div className="retangle">
          <p className="retangleTitle" style={{ color: '#0FA958' }}>Earnings (This Year)</p>
          <Grid container spacing={0} justifyContent='start'>
            <Grid item xs={3}>
              <img src="/img/tumpukan.png" height={50} width={50} style={{ marginTop: '5px' }} alt=''></img>
            </Grid>
            <Grid item xs={9}>
              <p className="content1">{earning.thisYear.count} Transactions</p>
              <p className="content2">{new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(earning.thisYear.earnings)}</p>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
    <div className="backgroundTable">
      <p className="tableTitle">Last Transactions</p>
      <TableContainer component={Paper} sx={{ marginBottom: '10px' }}>
        <Table aria-label="a dense table">
          <TableHead className="headerTable">
            <TableRow >
              <TableCell sx={headerTable}>Kode Transaksi</TableCell>
              <TableCell sx={headerTable}>Pembeli</TableCell>
              <TableCell sx={headerTable} >Produk</TableCell>
              <TableCell sx={headerTable} >Jumlah</TableCell>
              <TableCell sx={headerTable} >Total Harga</TableCell>
              <TableCell sx={headerTable} >Waktu Transaksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {limit.map((row, i) => (
              <TableRow key={i} sx={{ height: '0px', }}>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px', background: 'rgba(0, 102, 255, 0.25)' }}>
                  <Typography sx={rowTable}>{row.codeTrans}</Typography>
                </TableCell>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.user}</Typography></TableCell>
                <TableCell sx={{ border: 'none', background: 'rgba(0, 102, 255, 0.25)', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.product}</Typography></TableCell>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.amount}</Typography></TableCell>
                <TableCell sx={{ border: 'none', background: 'rgba(0, 102, 255, 0.25)', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.totalPrice}</Typography></TableCell>
                <TableCell sx={{ border: 'none', paddingTop: '8px', paddingBottom: '8px' }}><Typography sx={rowTable}>{row.transactionTime}</Typography></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <a className="linkk" href='/sellerDashboard/transactions'>Lihat Semua {">>"}</a>
    </div><br />
  </div>)

  return (
    <div>
      <PersistentDrawerLeft userData={setUser} components={ListTransaction} titleAppBar={'Dashboard'} />
    </div>
  );
}
